import { createContext } from 'react';

import type { Analytics } from './adapter';

const Context = createContext<Analytics>({} as Analytics);

export default Context;
